import { render } from "./MainSidebarNavList.vue?vue&type=template&id=1a755943&scoped=true"
import script from "./MainSidebarNavList.vue?vue&type=script&setup=true&lang=js"
export * from "./MainSidebarNavList.vue?vue&type=script&setup=true&lang=js"

import "./MainSidebarNavList.vue?vue&type=style&index=0&id=1a755943&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a755943"],['__file',"src/components/layout/MainSidebarNavList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a755943"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a755943', __exports__)) {
    api.reload('1a755943', __exports__)
  }
  
  module.hot.accept("./MainSidebarNavList.vue?vue&type=template&id=1a755943&scoped=true", () => {
    api.rerender('1a755943', render)
  })

}


export default __exports__